/**
 * AC-655 diagnostic — which signal next-intl resolved the request's locale from.
 *
 * - `prefix`  — a locale path prefix (`/es-mx/...`).
 * - `cookie`  — an existing `NEXT_LOCALE` cookie (possibly a stale pre-guard pin).
 * - `header`  — the `Accept-Language` header (its best match may still be `en`).
 * - `guess`   — none of the above; the default locale was served blind.
 *
 * `proxy.ts` computes it, forwards it to the render as a request header, and the
 * root layout stamps it on `<html>` so it shows up in Sentry's hydration diff and,
 * via `instrumentation-client.ts`, as the `locale_source` tag.
 */
export type LocaleSource = 'prefix' | 'cookie' | 'header' | 'guess';

export const LOCALE_SOURCE_HEADER = 'x-locale-source';

/** Written as `data-locale-source` on `<html>` in `app/layout.tsx`; read back via `dataset.localeSource`. */
export const LOCALE_SOURCE_ATTRIBUTE = 'data-locale-source';
